import { makeStyles, tokens, typographyStyles } from '@fluentui/react-components';

export const useSummaryPanelStyles = makeStyles({
  label: {
    color: tokens.colorNeutralForeground3,
    ...typographyStyles.body1Strong,
  },
  estimations: {
    ...typographyStyles.title3,
  },
  error: {
    color: tokens.colorPaletteRedForeground1,
  },
  shimmer: {
    width: '200px',
    marginTop: tokens.spacingVerticalS,
  },
});
